import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";
import withRouter from "components/Common/withRouter";

import {
    Button,
    Card,
    CardBody,
    Col,
    Container,
    Input,
    Row,
} from "reactstrap";
import CommonTable from "components/Common/TableContainer";
import NotificationAddEditModal from "pages/AllCommonModal/NotificationAddEditModal/notification-add-edit-modal";
import BroadcastAddEditModal from "pages/AllCommonModal/BroadcastNotificationAddEditModal/broadcast-notification-add-edit-modal";



const BroadcastNotification = () => {
    const [broadcastAddEditModalOpen, setBroadcastAddEditModalOpen] = useState(false);
    // User input in the search box
    const [searchTerm, setSearchTerm] = useState("");
    // Actual term to search when button is clicked
    const [searchQuery, setSearchQuery] = useState("");
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);


    const columns = [
        { Header: "Id", accessor: "id" },
        { Header: "Message", accessor: "message" },
        { Header: "Send To", accessor: "send_to" },
        { Header: "Schedule", accessor: "schedule" },
        { Header: "Status", accessor: "status" },
        { Header: "Update", accessor: "update" },
        { Header: "User", accessor: "user" },
    ];

    const companyData = [
        { id: 1, message: "Test Notification", send_to: "managers", schedule: "10:00 PM 03-22-2023", status: "Done", update: "3 years ago", user: "Ajay Pandey" },
        { id: 2, message: "Test Notification", send_to: "managers", schedule: "10:00 PM 03-22-2023", status: "Done", update: "3 years ago", user: "Ajay Pandey" }
    ];

    // 🔍 Filter only when search button clicked (uses searchQuery)
    const filteredData = useMemo(() => {
        if (!searchQuery.trim()) return companyData;

        return companyData.filter((item) =>
            Object.values(item).some((val) =>
                String(val).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
    }, [searchQuery]);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* View Modal */}
                    {/* 🔎 Search + Create Section */}
                    <Card className="border mb-3">
                        <CardBody>
                            <Row className="align-items-center g-2">
                                {/* Title */}
                                <Col xs="12" md="4" className="text-md-start text-center">
                                    <h5 className="fw-bold mb-0">Broadcast Notification</h5>
                                </Col>

                                {/* Search Box */}
                                <Col xs="12" md="5" className="d-flex justify-content-center justify-content-md-start">
                                    <div className={`d-flex border rounded w-100 ${isMobile? '' : "category-search-input"}`}>
                                        <Input
                                            type="text"
                                            placeholder="Search by name"
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                            className="border-0"
                                        />
                                        <Button
                                           className="search-icon-button"
                                            onClick={() => setSearchQuery(searchTerm.trim())}
                                        >
                                            <i className="fa fa-search"></i>
                                        </Button>
                                    </div>
                                </Col>

                                {/* Create Button */}
                                <Col xs="12" md="3" className="text-md-end text-center mt-2 mt-md-0">
                                    <Button
                                        color="primary"
                                        onClick={() => setBroadcastAddEditModalOpen(true)}
                                    >
                                        + New Message
                                    </Button>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>


                    {/* 📋 Table Section */}
                    <Card>
                        <CardBody>
                            {/* <div className="mb-4 h4 card-title">Latest Transaction</div> */}
                            <CommonTable columns={columns} data={filteredData} />
                        </CardBody>
                    </Card>

                    {/* 🧩 Add/Edit Modal */}
                    <BroadcastAddEditModal
                        setBroadcastAddEditModalOpen={setBroadcastAddEditModalOpen}
                        broadcastAddEditModalOpen={broadcastAddEditModalOpen}
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

BroadcastNotification.propTypes = {
    orders: PropTypes.array,
    onGetOrders: PropTypes.func,
};

export default withRouter(BroadcastNotification);
